// src/modules/Courier/pages/Route/ReceiptInfo/ReceiptInfo.jsx
import React, { useState }           from 'react';
import { useSwipeable }              from 'react-swipeable';
import { useRouteStore }             from '../useRouteStore';
import api                           from '../../../../services/api';
import styles                        from './ReceiptInfo.module.css';

const STATUS_COLORS = {
  "Открыта":      "#007bff",
  "Закрыта":      "#28a745",
  "Не доставлено":"#dc3545",
  "В обработке":  "#ffc107",
};



export default function ReceiptInfo({ receipt, navigate }) {
  // — Методы стора (не меняются между рендерами)
  const setSelectedReceiptId = useRouteStore(s => s.setSelectedReceiptId);
  const setModalPage         = useRouteStore(s => s.setModalPage);
  const updateReceipt        = useRouteStore(s => s.updateReceipt);
  const selectedReceiptId = useRouteStore(s => s.selectedReceiptId);
  // — Состояние, на которое подписываемся
  const modalPage        = useRouteStore(s => s.modalPage);
  const selectedReceipt  = useRouteStore(s => s.selectedReceipt);
  const receipts = useRouteStore(s => s.routeData?.receipts) || [];
  const openReceipts = receipts
    .filter(r => r.status === 'Открыта')
    .slice()
    .sort((a, b) => (a.sequence_number || Infinity) - (b.sequence_number || Infinity));

  const nextReceiptId = openReceipts[0]?.id;

  // Локальный UI-стейт для свайпа
  const [swipePos, setSwipePos]     = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const skipTypes  = ["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"];
  const allScanned = (receipt.products ?? []).every(
    p => !p.is_marked || (p.marks?.length ?? 0) >= p.actual_quantity
  );
  const status     = receipt.status;

  // Текст для чек-статуса
  let checkText;
  if (skipTypes.includes(receipt.payment_type))      checkText = 'Чек не нужен';
  else if (receipt.is_check_refunded)                checkText = 'Чек возвращён';
  else if (receipt.is_check_issued)                  checkText = 'Чек пробит';
  else                                               checkText = 'Чек не пробит';


let primaryLabel;
let secondaryLabel;

if (receipt.is_check_issued && receipt.status === 'Открыта') {
  primaryLabel   = 'Закрыть';
  secondaryLabel = 'Не доставлено';

} else if (allScanned && skipTypes.includes(receipt.payment_type) && status === 'Закрыта') {
  // 1) если всё отсканировано, оплата в skipTypes, и статус «Закрыта»
  primaryLabel   = 'Закрыта';
  secondaryLabel = 'Вернуть';

} else if (allScanned && skipTypes.includes(receipt.payment_type)) {
  // 2) если всё отсканировано и оплата в skipTypes (но статус не «Закрыта»)
  primaryLabel   = 'Закрыть';
  secondaryLabel = 'Не доставлено';

} else if (allScanned && !skipTypes.includes(receipt.payment_type)) {
  // 3) если всё отсканировано и оплата НЕ в skipTypes
  primaryLabel   = receipt.is_check_issued ? 'Посмотреть чек' : 'Сформировать чек';
  secondaryLabel = 'Не доставлено';

} else if (status === 'Не доставлено') {
  // 4) если ещё не всё отсканировано, но уже помечено «Не доставлено»
  primaryLabel   = 'Вернуть';
  secondaryLabel = 'Посмотреть причину';

} else {
  // 5) во всех остальных случаях
  primaryLabel   = 'Сканировать';
  secondaryLabel = status === 'Открыта' ? 'Не доставлено' : 'Вернуть';
}


  // ... внутри ReceiptInfo
const handleAction = dir => {
  setSelectedReceiptId(receipt.id);

  if (dir === 'right') {
        // 0) Если чек уже пробит, а квитанция ещё открыта – закрываем её
    if (receipt.is_check_issued && receipt.status === 'Открыта') {
      api.patch(`/receipts/${receipt.id}/status`, { status: 'Закрыта' })
        .then(res => {
          const updated = res.data ?? res;
          updateReceipt(updated);
        })
        .catch(err => {
          console.error('Не удалось закрыть квитанцию:', err);
          alert('Ошибка при закрытии квитанции');
        });
      // сразу выходим, чтобы не срабатывать дальше
      setSwipePos(0);
      return;
    }
    // 1) Если всё отсканировано и тип не в skipTypes — формируем или смотрим чек
    if (allScanned && !skipTypes.includes(receipt.payment_type)) {
      if (receipt.is_check_issued) {
        setModalPage('check');
      } else {
        // Сформировать чек — переходим на страницу dispatch
        setModalPage('dispatch');
      }
    }
    // 2) Если всё отсканировано и тип в skipTypes — сразу закрываем
    else if (allScanned && skipTypes.includes(receipt.payment_type)) {
      api.patch(`/receipts/${receipt.id}/status`, { status: 'Закрыта' })
        .then(res => {
          const updated = res.data ?? res;
          updateReceipt(updated);
        });
    }
    // 3) Если статус «Не доставлено» — возвращаем в работу
    else if (status === 'Не доставлено') {
      api.patch(`/receipts/${receipt.id}/status`, { status: 'Открыта' })
        .then(res => {
          const updated = res.data ?? res;
          updateReceipt(updated);
        });
    }
    // 4) Во всех остальных случаях — сканируем
    else {
      setModalPage('dispatch');
    }
  } 
  else {
    // Свайп влево:
    // Если закрыто — возвращаем в работу
    if (status === 'Закрыта') {
      api.patch(`/receipts/${receipt.id}/status`, { status: 'Открыта' })
        .then(res => {
          const updated = res.data ?? res;
          updateReceipt(updated);
        });
    }
    // Если открыто — ставим «Не доставлено»
    else if (status === 'Открыта') {
      setModalPage('failure')
      
    }
    // В других состояниях можно не обрабатывать
  }

  // Сбрасываем позицию слайдера
  setSwipePos(0);
};


  const handlers = useSwipeable({
    onSwiping: ({ deltaX, deltaY, absX, absY }) => {
      if (absY > absX) return;
      setIsDragging(true);
      setSwipePos(Math.min(Math.max(deltaX, -150), 150));
    },
    onSwiped: ({ deltaX, absX, absY }) => {
      setIsDragging(false);
      if (absY > absX) {
        setSwipePos(0);
        return;
      }
      if (absX > 100) {
        handleAction(deltaX > 0 ? 'right' : 'left');
      } else {
        setSwipePos(0);
      }
    },
        onTouchEnd: () => {
      setSwipePos(0);
      setIsDragging(false);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
     <div
   className={`${styles.cardContainer} ${
     receipt.id === selectedReceiptId ? styles.activeCard : ''
      }`}
      {...handlers}
    >
      {receipt.id === selectedReceiptId && (
        <i className={`bi bi-target ${styles.targetIcon}`} />
      )}
      <div className={styles.underlay}>
        <div className={`${styles.primaryUnderlay} ${
          primaryLabel === 'Сканировать'      ? styles.primaryScan :
          primaryLabel === 'Сформировать чек' ? styles.primaryMakeCheck :
          primaryLabel === 'Посмотреть чек'   ? styles.primaryViewCheck :
          primaryLabel === 'Закрыть'          ? styles.primaryClose :
          primaryLabel === 'Закрыта'          ? styles.primaryClose :
          primaryLabel === 'Вернуть'          ? styles.primaryReturn : ''
        }`}>
          {primaryLabel}
        </div>
        <div className={`${styles.secondaryUnderlay} ${
          secondaryLabel === 'Не доставлено' ? styles.secondaryFail :
          secondaryLabel === 'Посмотреть причину' ? styles.secondaryFail :
          secondaryLabel === 'Вернуть'       ? styles.secondaryReturn :
          ''
        }`}>
          {secondaryLabel}
        </div>
      </div>
        <div
              className={styles.slider}
              style={{
                transform: `translateX(${swipePos}px)`,
                transition: isDragging
                  ? 'none'
                  : 'transform 0.2s ease-out'
              }}
        >
        <div
          className={styles.indicator}
          style={{ backgroundColor: STATUS_COLORS[status] }}
        />
        <div className={styles.row}>
          {receipt.sequence_number > 0 && (
              <span
                className={`
                  ${styles.sequenceNumber}
                  ${receipt.id === nextReceiptId ? styles.nextSequence : ''}
                  ${['Закрыта','Не доставлено'].includes(receipt.status)
                    ? styles.fadedSequence : ''}
                `}
              >
                {receipt.sequence_number}
              </span>
              )}
           <span className={styles.address}>{receipt.delivery_address}</span>

          <span className={styles.payment}>
            {receipt.payment_type} - {receipt.to_pay}р.
          </span>
        </div>
        {(receipt.products ?? []).map(p => {
          const count = p.marks?.length ?? 0;
          const pct   = p.actual_quantity ? (count / p.actual_quantity) * 100 : 0;
          return (
            <div key={p.id} className={styles.productRow}>
              <span className={styles.productName}>
                {p.product_name}
              </span>
              <span className={styles.productQty}>
                x{p.actual_quantity}
              </span>

              {p.is_marked && (
                <>
                  <div className={styles.progressBase} />
                  <div
                    className={styles.progressBg}
                    style={{ width: `${pct}%` }}
                  />
                </>
              )}
            </div>
          );
        })}
        <div className={styles.rowBottom}>
          <div className={styles.rowInfo}>
            <span className={styles.time}>
              {receipt.delivery_time}
            </span>
            <span className={styles.checkStatus}>
              {checkText}
            </span>
          </div>
          <div className={styles.rowActions}>
          <i
            className={`bi bi-telephone ${styles.icon}`}
            onClick={e => {
              e.stopPropagation();
              setSelectedReceiptId(receipt.id);
              setModalPage('contacts');
            }}
          />
          <i
            className={`bi bi-map ${styles.icon}`}
            onClick={e => {
              e.stopPropagation();
              setSelectedReceiptId(receipt.id);
              setModalPage('map');
            }}
          />
          <i
            className={`bi bi-file-earmark-text ${styles.icon}`}
            onClick={e => {
              e.stopPropagation();
              setSelectedReceiptId(receipt.id);
              setModalPage('receipt');
            }}
          />
          </div>
        </div>
      </div>
    </div>
  );
}
